export default {
  updateCurrentMonth({ state, commit }, value) {
    commit('SET_OBJECT', { name: 'currentMonth', data: value, state })
  },
  updateSelectedModes({ state, commit }, value) {
    commit('SET_OBJECT', { name: 'selectedModes', data: value, state })
  },
  updateMariaSelected({ state, commit }, value) {
    commit('SET_OBJECT', { name: 'isMariaSelected', data: value, state })
  },
}
